/**
 * WinningOdds Component
 * Displays lottery odds in a standardized table format
 * 
 * Features:
 * - Server-rendered HTML (crawlable)
 * - Consistent "1 in X" format
 * - Uses official bonus names from centralized config
 */
import React from 'react';
import { LOTTERY_ODDS } from '@/data/lotteryOdds';

const WinningOdds = ({ lotteryCode }) => {
  const oddsData = LOTTERY_ODDS[lotteryCode];

  if (!oddsData) {
    return null;
  }

  return (
    <section className="mt-6">
      <h2 className="text-lg font-bold text-white mb-3">Winning Odds</h2>
      
      <div className="bg-gray-900/40 border border-gray-700/50 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-700/50">
              <th className="text-left py-2 px-4 text-gray-400 font-medium">Match</th>
              <th className="text-right py-2 px-4 text-gray-400 font-medium">Odds</th>
            </tr>
          </thead>
          <tbody>
            {oddsData.tiers.map((tier, index) => (
              <tr 
                key={index}
                className={index % 2 === 0 ? 'bg-gray-800/20' : 'bg-transparent'}
              >
                <td className="py-2 px-4 text-white">{tier.match}</td>
                <td className="py-2 px-4 text-gray-300 text-right font-mono">{tier.odds}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="mt-3 text-xs text-gray-500">
        All lottery draws are random. Odds are fixed by the game rules and do not change based on previous results.
      </p>
    </section>
  );
};

export default WinningOdds;
